import Arrow from './components/Arrow';
import Caret from './components/Caret';
import Circle from './components/Circle';
import Clock from './components/Clock';
import Cog from './components/Cog';
import CheckCircle from './components/CheckCircle';
import Cross from './components/Cross';
import CrossThin from './components/CrossThin';
import Download from './components/Download';
import Eye from './components/Eye';
import EyeCrossed from './components/EyeCrossed';
import Info from './components/Info';
import Invoice from './components/Invoice';
import Lock from './components/Lock';
import SymbolxMoney from './components/SymbolxMoney';
import Mail from './components/Mail';
import NavMenu from './components/NavMenu';
import Orders from './components/Orders';
import Organization from './components/Organization';
import Play from './components/Play';
import Plug from './components/Plug';
import PlugCrossed from './components/PlugCrossed';
import Plus from './components/Plus';
import QuestionCircle from './components/QuestionCircle';
import Settlements from './components/Settlements';
import Share from './components/Share';
import Store from './components/Store';
import CodeRec from './components/CodeRec';
import Gear from './components/Gear';
import Invoice2 from './components/Invoice2';
import ShoppingCart from './components/ShoppingCart';
import ShieldCheck from './components/ShieldCheck';

import { ReactComponent as Checkmark } from './files/checkmark.svg';
import { ReactComponent as Copy } from './files/copy.svg';
import { ReactComponent as DollarCircle } from './files/dollar-circle.svg';
import { ReactComponent as Document } from './files/document.svg';
import { ReactComponent as Dots } from './files/dots.svg';
import { ReactComponent as ErrorSign } from './files/error.svg';
import { ReactComponent as Logout } from './files/logout.svg';
import { ReactComponent as NoOrders } from './files/no_orders.svg';
import { ReactComponent as NoSettlements } from './files/no_settlements.svg';
import { ReactComponent as PlusBubble } from './files/plus_bubble.svg';
import { ReactComponent as Power } from './files/power.svg';
import { ReactComponent as Search } from './files/search.svg';
import { ReactComponent as SuspendedSettlements } from './files/suspended_settlements.svg';
import { ReactComponent as NoPersonal } from './files/no_personal.svg';
import { ReactComponent as Retry } from './files/retry.svg';
import { ReactComponent as BannerLogo } from './files/banner_logo.svg';
import { ReactComponent as Comment2Question } from './files/comment_2_question.svg';
import { ReactComponent as Bell } from './files/bell.svg';
import { ReactComponent as Question } from './files/question.svg';
import { ReactComponent as ExternalLink2 } from './files/external_link_2.svg';
import { ReactComponent as CheckCircleOutline } from './files/check_circle_outline.svg';
import { ReactComponent as Ai } from './files/ai.svg';
import { ReactComponent as Usdc } from './files/usdc.svg';
import { ReactComponent as Btc } from './files/btc.svg';
import { ReactComponent as Sui } from './files/sui.svg';
import { ReactComponent as Eth } from './files/eth.svg';
import { ReactComponent as Egld } from './files/egld.svg';
import { ReactComponent as Pol } from './files/pol.svg';
import { ReactComponent as Usdt } from './files/usdt.svg';
import { ReactComponent as UtK } from './files/utk.svg';
import { ReactComponent as Dash } from './files/dash.svg';
import { ReactComponent as Gift } from './files/gift.svg';
import { ReactComponent as GiftDuotone } from './files/gift-duotone.svg';
import { ReactComponent as Lock2 } from './files/lock-2.svg';
import { ReactComponent as Lock2Duotone } from './files/lock-2-duotone.svg';
import { ReactComponent as Lock2OpenedDuotone } from './files/lock-2-opened-duotone.svg';
import { ReactComponent as NewTab } from './files/new_tab.svg';
import { ReactComponent as Plus2 } from './files/plus-2.svg';
import { ReactComponent as TimeDuotone } from './files/time-duotone.svg';
import { ReactComponent as TrendUp } from './files/trend-up.svg';
import { ReactComponent as Wallet } from './files/wallet.svg';
import { ReactComponent as WalletDuotone } from './files/wallet-duotone.svg';
import { ReactComponent as CrossCircle } from './files/cross-circle.svg';
import { ReactComponent as CrossV2 } from './files/crossv2.svg';
import { ReactComponent as ArrowSwap } from './files/arrow-swap.svg';

export default {
  Ai,
  Arrow,
  ArrowSwap,
  BannerLogo,
  Bell,
  Caret,
  Circle,
  CheckCircle,
  CheckCircleOutline,
  Checkmark,
  Clock,
  CodeRec,
  Cog,
  Comment2Question,
  Copy,
  Cross,
  CrossCircle,
  CrossThin,
  CrossV2,
  DollarCircle,
  Document,
  Dots,
  Download,
  ErrorSign,
  Eye,
  EyeCrossed,
  ExternalLink2,
  Gear,
  Gift,
  GiftDuotone,
  Info,
  Invoice,
  Invoice2,
  Lock,
  Lock2,
  Lock2Duotone,
  Lock2OpenedDuotone,
  SymbolxMoney,
  Logout,
  Mail,
  NavMenu,
  NoOrders,
  NoSettlements,
  NoPersonal,
  Orders,
  Organization,
  Play,
  Plug,
  PlugCrossed,
  Plus,
  Plus2,
  PlusBubble,
  Power,
  QuestionCircle,
  Question,
  Retry,
  Search,
  Settlements,
  Share,
  ShieldCheck,
  SuspendedSettlements,
  Store,
  ShoppingCart,
  TimeDuotone,
  TrendUp,
  Usdc,
  Btc,
  Sui,
  Eth,
  Egld,
  Pol,
  Usdt,
  UtK,
  Dash,
  NewTab,
  Wallet,
  WalletDuotone,
};
